import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { designTokens, baseColors } from "theme";

export const styles = (theme: Theme) => {
	return {
		card: {
			backgroundColor: designTokens.colors.white,
			border: `1px solid ${designTokens.colors.borderCard}`,
			borderRadius: 8,
			padding: theme.spacing(3),
			width: "100%",
			boxSizing: "border-box",
		},
		title: {
			fontSize: 18,
			fontWeight: 700,
			color: theme.palette.custom.textPrimary,
			marginBottom: theme.spacing(3),
		},
		row: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			padding: "14px 0",
			borderBottom: `1px solid ${designTokens.colors.divider}`,
			"&:last-child": {
				borderBottom: "none",
			},
			"&:hover": {
				backgroundColor: designTokens.colors.grayLight,
			},
		},
		rowMain: {
			flex: 1,
			minWidth: 0,
		},
		rowHeader: {
			display: "flex",
			alignItems: "center",
			gap: 10,
			marginBottom: 4,
		},
		date: {
			fontSize: 14,
			fontWeight: 600,
			color: baseColors.darkCharcoal,
		},
		preview: {
			fontSize: 14,
			color: designTokens.colors.grayDark,
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis",
			paddingRight: theme.spacing(2),
		},
		rowMeta: {
			display: "flex",
			alignItems: "center",
			gap: 8,
			flexShrink: 0,
		},
		messageCount: {
			fontSize: 12,
			color: designTokens.colors.grayDark,
			whiteSpace: "nowrap",
		},
		chevron: {
			fontSize: 16,
			color: baseColors.gray,
		},
		// Shared by the empty and load-failure states.
		message: {
			fontSize: 16,
			lineHeight: "24px",
			fontWeight: 400,
			color: theme.palette.custom.textSecondary,
			textAlign: "left",
			textWrap: "pretty",
		},
	} satisfies Record<string, CSSObject>;
};
